import React, { useEffect, useState } from 'react';
import SimpleCard from '../components/SimpleCard_extraText';
import logo from '../assets/images/logo.png';
import styles from '../styles/pages/aboutuspage.module.css';
import { useAuth } from "../authentication/AuthContext";
import axios from 'axios';
import ModalMEImage from '../components/ModalMEImage';

function ManagementExecutives() {
    const [images, setImages] = useState([]);
    const { isAuthenticated } = useAuth();

    const fetchImages = () => {
        axios.get("/api/ME_images")
            .then((response) => {
                const data = response.data.map((img) => ({
                    id: img._id,
                    _id: img._id,
                    name: img.name,
                    designation: img.designation,
                    img: `/api/ME_images/${img._id}`,
                }));
                setImages(data);
            })
            .catch((err) => console.error("Error fetching images:", err));
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const Extra = () => <img className={styles.logo_bg_side} src={logo} />;
    const Filler = () => null;

    return (
        <div className='body'>
            <div className='heading'>
                MANAGEMENT EXECUTIVES
            </div>
            <hr />
            <hr />
            {isAuthenticated && (
                <ModalMEImage
                value={images}
                label="image"
                refresh={fetchImages}
              />
              
            )}
            <div className='body'>
                <div className={styles.executives}>
                    <SimpleCard list={images} extra={Extra} />
                </div>
            </div>
        </div>
    );
}

export default ManagementExecutives;
